module.exports = __webpack_public_path__ + "img/material-empty.4433fe4f.gif";